<template>
  <div @click="navigateToLead" class="
  sm:ut--mx-0 table-body md:ut-rounded ut-bg-neutral-001 md:ut-flex ut-mb-2 ut-h-50 md:ut-h-20"
  v-gaEvent="{ category: 'AgentPortal', action: 'Lead list view lead', label: gaLabel }">
  <!-- v-ga="$ga.commands.ga.bind(this, {category: 'AgentPortal', action: 'Lead list view lead', label: gaLabel})"> -->

    <div class="ut-pt-6 ut-flex md:ut-pt-0 ut-pl-4 md:ut-w-3/5 md:ut-pl-6">
      <div class="ut-flex ut-ml-0">
        <div class="ut-m-0 ">
          <first-initial-name :small="true" :str="lead.leadinfo.firstname"></first-initial-name>
        </div>

        <div class="ut-ml-2 md:ut-ml-6 ut-my-auto ut-text-dark-green-400 ut-text-sm ut-font-bold">
          {{ vendorFullName | titleCase | truncateString(20) }}
        </div>
      </div>

      <div class="md:ut-hidden ut-mr-4 ut-block ut-py-2" v-if="!onHold">
        <pill :danger="isActive && requiredUpdate" :happy="isListed">
          <span v-if="isActive">Updated {{ (lead.agentlastupdatedate || lead.modifieddate) | ago }}</span>
          <span v-if="isListed">{{ listedPillTxt }}</span>
          <span v-if="isClosed">{{ closedPillTxt }}</span>
        </pill>
      </div>

      <div class="md:ut-hidden ut-mr-4 ut-block ut-py-2 ut-w-1/2" v-if="onHold">
        <pill :danger="isActive && requiredUpdate" :happy="isListed">
          <span>
            On hold until {{ lead.lamoffholddatetime | formatDate("D MMM YYYY") }}
          </span>
        </pill>
      </div>

    </div>
    <!--<div class="md:ut-hidden divider ut-mt-6"></div>-->

    <!-- <div class="md:ut-hidden divider ut-mb-4"></div> -->
    <div class="md:ut-hidden ut-flex">
      <div class="ut-ml-6 ut-py-4">
        <div class="font-xxs">ADDRESS</div>
        <div class="font-small">{{ leadAddress | truncateString(40) }}</div>
      </div>
      <div class="lead-card-col-small ut-ml-6">
        <div class="font-xxs">DATE SENT</div>
        <div class="font-small">
          {{ lead.agentsentleaddate | formatDate("D MMM YYYY") }}&nbsp;
        </div>
      </div>
      <div class="lead-card-col-small">
        <div class="font-xxs">STAGE</div>
        <div class="font-small">{{ agentStageName }}</div>
      </div>
    </div>

    <div class="ut-w-3/5 ut-pl-6 ut-hidden md:ut-block">
      <div class="font-small">{{ leadAddress | truncateString(40) }}</div>
    </div>
    <div class="ut-w-2/5 ut-pl-6 ut-hidden md:ut-block">
      <div class="font-small">{{ lead.agentsentleaddate | formatDate("D MMM YYYY") }}</div>
    </div>
    <div v-if="!isClosed" class="ut-w-2/5 ut-pl-6 ut-hidden md:ut-block">
      <div v-if="!isListed" class="font-small">{{ agentStageName }}</div>
      <div v-if="isListed" class="font-small"> {{ lead.leadinfo.soldprice | formatPrice('$') }}</div>
    </div>
    <div class="ut-w-3/5 ut-pl-6 ut-hidden md:ut-block" v-if="!onHold">
      <pill :danger="isActive && requiredUpdate" :happy="isListed">
        <span v-if="isActive">Updated {{ (lead.agentlastupdatedate || lead.modifieddate) | ago }}</span>
        <span v-if="isListed">{{ listedPillTxt }}</span>
        <span v-if="isClosed">{{ closedPillTxt }}</span>
      </pill>
    </div>
    <div class="ut-w-4/5 ut-pl-6 ut-hidden md:ut-block" v-if="onHold">
      <pill :danger="isActive && requiredUpdate" :happy="isListed">
        <span>
          On hold until {{ lead.lamoffholddatetime | formatDate("D MMM YYYY") }}
        </span>
      </pill>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';
import Pill from '@/components/Pill.vue';
import { LeadAgentLeadStageType, LeadAgentLeadStageTypeId } from '@/Mapper/LeadAgentLeadStageType';
import { LeadAgentLeadStateType } from '@/Mapper/LeadAgentLeadStateType';
import { LeadStageType } from '@/Mapper/LeadStageType';
import FirstInitialName from '@/components/FirstInitialName.vue';

const moment = require('moment-business-days');

export default {
  name: 'LeadCard',
  components: {
    Pill,
    FirstInitialName,
  },
  data() {
    return {
      showOnHoldModal: false,
      showCloseLeadModal: false,
    };
  },
  props: {
    lead: {
      required: true,
    },
    lastUpdateDay: {
      default: 1,
    },
    onHold: {
      default: false,
    },
    isActive: {
      default: false,
    },
    isListed: {
      default: false,
    },
    isClosed: {
      default: false,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    gaLabel() {
      return `AID=${this.lead.agentid} | ${this.getCurrentTab()} | LeadId=${this.lead.leadinfo.id}`;
      // return `AID=${this.agent.id} | ${this.getCurrentTab()} | LeadId=${this.lead.leadinfo.id}`;
    },
    agentStageName() {
      return LeadAgentLeadStageTypeId[this.lead.stagetypeid];
    },
    requiredUpdate() {
      if (!this.lead.agentlastupdatedate) return true;
      const date = moment(new Date(`${this.lead.agentlastupdatedate} UTC`));
      if (this.isActive) {
        /**
        * Referred and Viewed
        * always action required (red)
        */
        if (this.lead.stagetypeid === LeadAgentLeadStageType.Referred
        || this.lead.stagetypeid === LeadAgentLeadStageType.Viewed) return true;

        /**
         * Attempted
         * if updated more than 1 business day ago --> action required (red)
         * if updated less than 1 business day ago --> action not required (gray)
         */
        if (this.lead.stagetypeid === LeadAgentLeadStageType.Attempted) {
          return (moment().utc().businessDiff(date, 'days') >= 1);
        }

        /**
         * Contacted
         * if updated more than 7 business day ago --> action required (red)
         * if updated less than 7 business day ago --> action not required (gray)
         */
        if (this.lead.stagetypeid === LeadAgentLeadStageType.Contacted_Vendor) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }

        /**
         * Appraised
         * if updated more than 7 business day ago --> action required (red)
         * if update less than 7 business day ago --> action not required (gray)
         */
        if (this.lead.stagetypeid === LeadAgentLeadStageType.Appraised) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }

        /**
         * Appointed
         * if updated more than 7 business day ago --> action required (red)
         * if updated less than 7 business day ago --> action not required (gray)
         */
        if (this.lead.stagetypeid === LeadAgentLeadStageType.Appointed) {
          return (moment().utc().businessDiff(date, 'days') >= 7);
        }
      }

      /**
      * On hold --> action not required (grey)
      */


      /**
      * Listed --> action not required happy color (green)
      */

      /**
      * Closed --> action not required (gray)
      */

      return false;
    },
    listedPillTxt() {
      return (this.lead.leadinfo.leadstageid === LeadStageType.Sold
        || this.lead.leadinfo.leadstageid === LeadStageType.Reviewed)
        ? `Sold ${this.$options.filters.formatDate(this.lead.leadinfo.solddate)}`
        : `Listed ${this.$options.filters.formatDate(this.lead.leadinfo.listingdate)}`;
    },
    closedPillTxt() {
      return (this.lead.statetypeid === LeadAgentLeadStateType.Closed)
        ? `Closed on ${this.lead.leaddeclineddate && this.lead.leaddeclineddate.length > 0
          ? this.$options.filters.formatDate(this.lead.leaddeclineddate)
          : this.$options.filters.formatDate(this.lead.modifieddate)}`
        : `Lost on ${this.lead.leadlostdate && this.lead.leadlostdate.length > 0
          ? this.$options.filters.formatDate(this.lead.leadlostdate)
          : this.$options.filters.formatDate(this.lead.modifieddate)}`;
    },
    vendorFullName() {
      return `${this.lead.leadinfo.firstname}${this.lead.leadinfo.lastname ? ` ${this.lead.leadinfo.lastname}` : ''}`;
    },
    leadAddress() {
      return `${this.lead.leadinfo.streetaddress
        ? `${this.lead.leadinfo.streetaddress},`
        : ''} ${this.lead.leadinfo.suburb}`;
    },
  },
  methods: {
    navigateToLead() {
      this.$apiServices.oa.agent.getById(this.lead.agentid)
        .then((agentData) => {
          this.$router.push({
            path: `/${agentData.key}/lead/${this.lead.leadinfo.key}${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
          });
        });
    },
    getCurrentTab() {
      if (this.onHold) return 'On hold';
      if (this.isActive) return 'Active';
      if (this.isListed) return 'Listed';
      if (this.isClosed) return 'Closed';
    },
  },
};

</script>

<style scoped lang="scss">

.table-body {
  border: 1px solid #E3E5E8;

  &:hover {
    border: none;
    @apply ut-shadow-md;
    cursor: pointer;
  }
}

.divider {
  @apply ut-mx-4 ut-h-px ut-opacity-25 ;
  border: 1px solid #979797;

}

.vendor-avatar2 {
  height: 32px;
  width: 32px;
  background-color: #125e60;
  font-size: 16px;
  @apply ut-text-center ut-font-bold ;
  color:#ffffff;

  @screen md {
    height: 32px;
    width: 32px;
    font-size: 16px;
  }
}

.lead-card-col-small {
  float: left;
  @apply ut-mr-8 ;
}

.font-small {
  @apply ut-opacity-100 ;
  @screen md {
    @apply ut-opacity-75;
  }
}

</style>
